export const USER_CANCELLED_STATUS_CODE = 'CANCELED';

export const CODE_DEFECT_ERROR_NAMES = new Set([
  'TypeError',
  'ReferenceError',
  'RangeError',
  'SyntaxError',
  'PaymentContractError',
]);

export const SDK_MISUSE_MESSAGES = ['can only be called one at a time'];

export const HYPERSWITCH_DEFECT_CODE = {
  NO_PAYMENT_METHOD: 'hyperswitch_no_payment_method',
  INTENT_UNUSABLE: 'hyperswitch_intent_unusable',
} as const;

export const CODE_DEFECT_FAILURE_CODES = new Set<string>(Object.values(HYPERSWITCH_DEFECT_CODE));
